import { TopicStateComponent } from "../topic-state.component";

import { Component, OnInit, HostBinding, ChangeDetectionStrategy, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";

import { map } from "rxjs/operators";

import { WebCallTopicService } from "@onsip/common/services/api/resources/webCallTopic/web-call-topic.service";
import { ConfigurationService } from "../services/configuration.service";
import { TranslateService } from "@ngx-translate/core";

import { DocumentVersionErrorModalComponent } from "../errorModals/documentVersion/document-version-error-modal.component";
import { GenericErrorModalComponent } from "../errorModals/genericError/generic-error-modal.component";

import { views } from "../../../../app/phone/views";

import { OrganizationConfigurationFileError } from "@onsip/common/services/api/apiErrorCodes";
import { SnackbarService } from "@onsip/web/features/shared/components/snackbar/snackbar.service";
import { TopicFormService } from "../services/topic-form.service";

@Component({
  templateUrl: "./sayso-topic-edit.component.html",
  styleUrls: [
    "../topicWriteForm/topic-write-form.component.scss" // parent/shared
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

// eslint-disable-next-line rxjs-angular/prefer-composition
export class SaysoTopicEditComponent extends TopicStateComponent implements OnInit, OnDestroy {
  @HostBinding("class.onsip-no-grid")
  _dontUse = true;

  views = views;
  form!: FormGroup;
  saving = false;
  public mode!: "edit" | "duplicate";

  constructor(
    private router: Router,
    private translate: TranslateService,
    private config: ConfigurationService,
    private snackbarService: SnackbarService,
    private dialog: MatDialog,
    private topicForm: TopicFormService,
    private webCallTopicService: WebCallTopicService,
    protected route: ActivatedRoute
  ) {
    super(route);
  }

  ngOnInit() {
    super.ngOnInit();
    this.topicForm.reset();
    this.form = this.topicForm.getForm() as FormGroup;
    this.unsubscriber.add(
      this.route.data.pipe(map(data => data.mode)).subscribe(mode => (this.mode = mode))
    );
  }

  ngOnDestroy() {
    this.unsubscriber.unsubscribe();
  }

  navToView(topicTarget: string): Promise<boolean> {
    return this.router.navigate([views.SAYSO_VIEW], {
      state: {
        topicTarget,
        skipLocationChange: true,
        replaceUrl: true
      }
    });
  }

  submit() {
    this.topicForm.sendSubmitEvent();
    if (this.form.valid) {
      const configurationPatch = this.topicForm.getConfigurationPatch(),
        filters = this.topicForm.getFilters(),
        reps = this.topicForm.getReps(),
        documentVersionToBe = this.config.documentVersion + 1;
      if (this.mode === "edit") {
        const foundTopic = this.webCallTopicService.findTopic(this.target);
        if (!foundTopic || !foundTopic.configuration) {
          throw new Error("Topic configuration not found in webcalltopics");
        }
        const newConfiguration = {
          ...Object.assign(foundTopic.configuration, configurationPatch),
          filters: { ...Object.assign(foundTopic.configuration.filters, filters) }
        };

        this.webCallTopicService
          .webCallTopicEdit(this.target, newConfiguration, reps, documentVersionToBe)
          .then(result => {
            if (result.status === "success") {
              this.saveComplete();
            } else {
              const error = result.data;
              this.handleApiError(error);
              this.webCallTopicService.clearErrors();
            }
          });
      } else {
        this.webCallTopicService
          .webCallTopicAdd(configurationPatch, filters, reps, "random", documentVersionToBe)
          .then(result => {
            if (result.status === "success") {
              this.saveComplete();
            } else {
              const error = result.data;
              this.handleApiError(error);
              this.webCallTopicService.clearErrors();
            }
          });
      }
      this.saving = true;
      this.form.disable();
    } else {
      this.snackbarService.openSnackBar(
        this.translate.instant("ONSIP_I18N.TOPIC_NOT_SAVED"),
        "error"
      );
    }
  }

  private saveComplete() {
    this.config.updateDocumentVersion();
    this.saving = false;
    this.form.enable();
    this.navToView(this.target);
    this.snackbarService.openSnackBar(this.translate.instant("ONSIP_I18N.TOPIC_SAVED"), "success");
  }

  private handleApiError(error: any) {
    if (error) {
      switch (error.code) {
        case OrganizationConfigurationFileError.INVALID_DOCUMENT_VERSION:
          this.dialog.open(DocumentVersionErrorModalComponent, {
            disableClose: true,
            closeOnNavigation: false,
            panelClass: ["mat-typography", "onsip-dialog-universal-style"]
          });
          break;
        default:
          this.dialog.open(GenericErrorModalComponent, {
            disableClose: true,
            closeOnNavigation: false,
            panelClass: ["mat-typography", "onsip-dialog-universal-style"]
          });
          break;
      }
      this.webCallTopicService.clearErrors();
    }
  }
}
